﻿import { htmlPromise } from './fetch'

export async function translate(path) {
	const currentLanguage = document.querySelector('html').getAttribute('lang');
	const result = await htmlPromise(`/Localization/GetSingleTranslationByPath?path=${path}&lang=${currentLanguage}`).catch((err) => err);
	
	if (result.status !== 200)
		return path;

	return result.body;
}